export default __webpack_public_path__ + "static/media/poster.6e80d905.jpg";